import { decodeJwt, DecodedJwt } from "@egis-auth/jwt-utils";

export default abstract class AbstractTokenStorage<
  JwtType extends DecodedJwt = DecodedJwt
> {
  /**
   * Decode a JWT
   * @param token Token to decode
   * @throws
   */
  public decodeJwt(token: string): JwtType {
    return decodeJwt<JwtType>(token);
  }

  public abstract getToken(): JwtType;
  public abstract getRawToken(): string;
  public abstract setToken(token: string): void;
  public abstract removeToken(): void;
}
